import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import NameInput from './pages/NameInput';
import Home from './pages/Home';
import SubjectSelection from './pages/SubjectSelection';
import LectureExercise from './pages/LectureExercise';
import EcritureExercise from './pages/EcritureExercise';
import MathExercise from './pages/MathExercise';
import PoesieExercise from './pages/PoesieExercise';
import CountingExercise from './pages/CountingExercise';
import CountingDownExercise from './pages/CountingDownExercise';
import CollectionComparison from './pages/CollectionComparison';
import DecorativeElements from './components/DecorativeElements';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <div className="App">
        <DecorativeElements />
        <div className="container">
          <Routes>
            <Route path="/" element={<NameInput />} />
            <Route path="/home" element={<Home />} />
            <Route path="/subjects" element={<SubjectSelection />} />
            <Route path="/lecture/:level" element={<LectureExercise />} />
            <Route path="/ecriture/:level" element={<EcritureExercise />} />
            <Route path="/math/:level" element={<MathExercise />} />
            <Route path="/poesie/:level" element={<PoesieExercise />} />
            <Route path="/counting" element={<CountingExercise />} />
            <Route path="/counting-down" element={<CountingDownExercise />} />
            <Route path="/collection-comparison" element={<CollectionComparison />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
